import React from "react";
import Osm from "./osm/index";
import Google from "./googleMaps/index";
import { Navbar } from "../../main/navbar";
import { ViewOrderMonitoring } from "../../view-order/monitoring";
import styles from './style.module.css';
import { Route } from 'react-router-dom';
import MapNewOrderSelectPin from "../Map-NewOrder-Select-pin";
import MapEditOrderSelectPin from "../Map-EditOrder-Select-pin";



export class MapContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mapReady: false
        }
        this.intervalMap = null
    }

    componentDidMount() {
        if (!global.config.dispatcherSettings?.applicationMap) {

            this.intervalMap = setInterval(() => {
                if (global.config.dispatcherSettings?.applicationMap) {
                    clearInterval(this.intervalMap)
                    this.intervalMap = null;
                    this.setState({
                        mapReady: true
                    })
                }
            }, 200);
        } else {
            this.setState({
                mapReady: true
            })
        }
    }


    childrenWithProps = () => {
        return React.Children.map(this.props.children, child => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, { mapType: global.config.dispatcherSettings.applicationMap ? global.config.dispatcherSettings.applicationMap.type : null ,clusters: this.props.clusters , supercluster: this.props.supercluster  });
            }
            return child;
        });
    }


    render() {

         let xx = (String(window.location.href).includes("/PickupDelivery/map"))

        // return <Osm {...this.props}>
        //     {this.childrenWithProps()}
        // </Osm>

        // return <Google  {...this.props}>
        //     {this.childrenWithProps()}
        // </Google>


        if (this.state.mapReady) {
             if (global.config.dispatcherSettings.applicationMap.type == "google") {
                // return <div style={{ width:this.props.style.width , transition:"all 260ms ease-in-out"}}><Navbar isViewOrder={false}   />

                return <div style={{ width:"auto" , flex :"1" , transition:"all 260ms ease-in-out"}}> 
                   {!xx && <Navbar isViewOrder={false}   />}
                     <Google {...this.props}>
                         {this.childrenWithProps()}
                     </Google>
                     <Route path="/Ondemand" exact>
                         <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ zIndex: "8", marginInlineStart: "32px" }}>
                             <ViewOrderMonitoring />
                         </div>
                     </Route>
                     <Route path="/Delivery" exact>
                     <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ zIndex: "8", marginInlineStart: "32px" }}>
                             <ViewOrderMonitoring />
                         </div>
                     </Route>


                     <Route path="/Pickup" exact>
                      <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ zIndex: "8", marginInlineStart: "32px" }}>
                             <ViewOrderMonitoring />
                         </div>

                     </Route>
                 </div>
             } else {
                 return <div  style={{ width:"auto" , flex :"1" , transition:"all 260ms ease-in-out" , position :"relative" }}>
                   {!xx && <Navbar isViewOrder={false} />}
                     <Osm {...this.props}>
                         {this.childrenWithProps()}
                     </Osm>
                 <MapNewOrderSelectPin FORCE={true}  isOsm={true}  />
                 <MapEditOrderSelectPin  isOsm={true}  />
                     
                            <Route path="/Ondemand" exact>
                         <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ zIndex: "8", marginInlineStart: "32px" }}>
                             <ViewOrderMonitoring />
                         </div>
                     </Route>
                     <Route path="/Delivery" exact>
                     <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ zIndex: "8", marginInlineStart: "32px" }}>
                             <ViewOrderMonitoring />
                         </div>
                     </Route>


                     <Route path="/Pickup" exact>
                      <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ zIndex: "8", marginInlineStart: "32px" }}>
                             <ViewOrderMonitoring />
                         </div>

                     </Route>
                </div>
            }
        } else {
            return (null)
        }

    }
}


